var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var DataLayerService = /** @class */ (function () {
    function DataLayerService() {
        this.defaultCurrency = 'AZN';
    }
    DataLayerService.prototype.ensureDataLayer = function () {
        window.dataLayer = window.dataLayer || [];
        return window.dataLayer;
    };
    DataLayerService.prototype.normalizeNumber = function (value) {
        var normalized = typeof value === 'string' ? Number(value.replace(',', '.')) : Number(value);
        if (!Number.isFinite(normalized)) {
            return 0;
        }
        return Math.round((normalized + Number.EPSILON) * 100) / 100;
    };
    DataLayerService.prototype.normalizeItems = function (items) {
        var _this = this;
        return items.map(function (item) { return (__assign(__assign({}, item), { price: _this.normalizeNumber(item.price), quantity: item.quantity || 1 })); });
    };
    DataLayerService.prototype.push = function (payload) {
        console.log('[GTM dataLayer push]', payload);
        this.ensureDataLayer().push(payload);
    };
    DataLayerService.prototype.funnelStep = function (payload) {
        this.push({
            event: 'funnel_step',
            insurance_type: payload.insuranceType,
            step_number: payload.stepNumber,
            step_name: payload.stepName,
            custom_details: payload.customDetails || {}
        });
    };
    DataLayerService.prototype.addToCart = function (payload) {
        this.push({
            event: 'add_to_cart',
            insurance_type: payload.insuranceType,
            ecommerce: {
                currency: payload.currency || this.defaultCurrency,
                value: this.normalizeNumber(payload.value),
                items: this.normalizeItems(payload.items)
            }
        });
    };
    DataLayerService.prototype.beginCheckout = function (payload) {
        this.push({
            event: 'begin_checkout',
            insurance_type: payload.insuranceType,
            ecommerce: {
                currency: payload.currency || this.defaultCurrency,
                value: this.normalizeNumber(payload.value),
                items: this.normalizeItems(payload.items)
            }
        });
    };
    DataLayerService.prototype.purchase = function (payload) {
        this.push({
            event: 'purchase',
            insurance_type: payload.insuranceType,
            ecommerce: {
                transaction_id: payload.transactionId,
                value: this.normalizeNumber(payload.value),
                currency: payload.currency || this.defaultCurrency,
                coupon: payload.coupon || '',
                items: this.normalizeItems(payload.items)
            }
        });
    };
    return DataLayerService;
}());
var dataLayerService = new DataLayerService();
export default dataLayerService;
